import { FC, Fragment, JSX } from 'react';
import { Box, Button, Card, CardActions, CardContent, Grid } from '@mui/material';
// components
import InputController from 'controller/InputController';
import ProductTypesSelector from 'components/common/selectors/productTypeMulti';
// constants, styles, interfaces
import { BottleSizeFormProps } from 'interfaces';
import { flexMarginTopEndCenter, forInputLabelBg } from 'styles/commonComponentStyle';
import { CC_TEXT, LID_SIZE_TEXT, NAME_TEXT, OZ_TEXT, PRODUCT_TYPE_TEXT, SAVE_TEXT } from 'constants/index';

const BottleSizeForm: FC<BottleSizeFormProps> = ({ isEdit = false, loading = false }): JSX.Element => {
  return (
    <Card sx={forInputLabelBg}>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12} lg={12}>
            <InputController isRequired fieldType="text" name="name" disabled={loading} title={NAME_TEXT} />
          </Grid>
          <Grid item xs={12} lg={12}>
            <InputController name="lidSize" fieldType="number" disabled={loading} title={LID_SIZE_TEXT} />
          </Grid>
          <Grid item xs={12} lg={12}>
            <InputController fieldType="number" name="cc" disabled={loading} title={CC_TEXT} />
          </Grid>
          <Grid item xs={12} lg={12}>
            <InputController fieldType="number" name="oz" disabled={loading} title={OZ_TEXT} />
          </Grid>

          <Grid item xs={12} lg={12}>
            <ProductTypesSelector title={PRODUCT_TYPE_TEXT} isRequired name="productTypes" />
          </Grid>
        </Grid>
      </CardContent>

      {isEdit ? (
        <CardActions>
          <Box sx={flexMarginTopEndCenter}>
            <Button type="submit" variant="contained" size="small" disabled={loading}>
              {SAVE_TEXT}
            </Button>
          </Box>
        </CardActions>
      ) : (
        <Fragment />
      )}
    </Card>
  );
};

export default BottleSizeForm;
